export const getSelectOptions = (options) => Object.entries(options).map(([key, value]) => ({ label: value, value: key }));
